/**
 * @author Andres Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
    Toolbar,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioBodegasTiposPropiedadesVistaProps } from '../interfaces';
const FormularioBodegasTiposPropiedadesVista: React.FunctionComponent<IFormularioBodegasTiposPropiedadesVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    bodegasTiposPropiedades,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'bodegasTiposPropiedades.agregarBodegasTiposPropiedades'
                                : 'bodegasTiposPropiedades.modificarBodegasTiposPropiedades'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="bodegasTiposPropiedades.bodegaTipoPropiedadDescripcion" display="inline" />}
                        name="BodegaTipoPropiedadDescripcion"
                        onChange={cambiarInfoFomulario}
                        required
                        value={bodegasTiposPropiedades.BodegaTipoPropiedadDescripcion}
                        id={`CampoBodegaTipoPropiedadDescripcion-${bodegasTiposPropiedades.BodegaTipoPropiedadId}`}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="bodegasTiposPropiedades.propiedad" display="inline" />}
                        name="Propiedad"
                        onChange={cambiarInfoFomulario}
                        required
                        value={bodegasTiposPropiedades.Propiedad}
                        id={`CampoPropiedad-${bodegasTiposPropiedades.Propiedad}`}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(bodegasTiposPropiedades.Estado) === 1 ? true : false}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="productos.estado" display="inline" />}
                        name="Estado"
                        id={`Estado`}
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <Button onClick={cerrarFormulario} color="secondary" variant="contained" id="boton-cancelar">
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={accionCrearEditar} color="primary" variant="contained" id="boton-editar">
                        <Texto id={tipoFormulario === TipoFormulario.Creacion ? 'boton.guardar' : 'boton.editar'} />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioBodegasTiposPropiedadesVista;
